module.exports = __webpack_public_path__ + "media/images/service/w_fm-7c550f6521984cde1c08f208b347ab0a.png";